import axios from 'axios';
import { CONTACTS_IMPORT_MAX_SIZE_MB } from '../config/import-file';

const FILE_MAX_SIZE_REACHED = 'FILE_MAX_SIZE_REACHED';
const MAX_UPLOAD_LIMIT_REACHED = 'MAX_UPLOAD_LIMIT_REACHED';

const isAPIError = error => {
  return error && error.data && error.data.error;
};

const isMaxFileSizeError = error => {
  if (!isAPIError(error)) {
    return false;
  }
  return error.data.error === FILE_MAX_SIZE_REACHED;
};

const isMaxUploadLimit = error => {
  if (!isAPIError(error)) {
    return false;
  }
  return error.data.error === MAX_UPLOAD_LIMIT_REACHED;
};

export default {
  namespaced: true,
  state: {
    hasError: false,
    error: null,
    loading: false,
    requestProgress: 0,
    data: null,
    uploadedFile: null,
  },
  mutations: {
    setError(state, error) {
      state.error = error;
      state.hasError = !!error;
    },
    setData(state, data) {
      state.data = data;
    },
    setUploadedFile(state, uploadedFile) {
      state.uploadedFile = uploadedFile;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    clearMessages(state) {
      state.loading = false;
      state.error = null;
      state.hasError = false;
      state.requestProgress = 0;
      state.uploadedFile = null;
      state.data = null;
    },
    setRequestProgress(state, requestProgress) {
      state.requestProgress = requestProgress;
    },
  },
  actions: {
    async uploadImportFile({ commit }, { type, file, sampleSize }) {
      commit('setLoading', true);
      try {
        const data = {
          type,
          file_name: file.name,
          file_size: file.size,
        };

        const params = {
          sample_data: sampleSize,
        };

        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        formData.append('file', file, file.name);
        const response = await axios.post(
          `${process.env.VUE_APP_FILE_UPLOADER_API_BASE_URL}/upload/import-file`,
          formData,
          {
            onUploadProgress: progressEvent => {
              const precentCompleted = Math.floor(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              commit('setRequestProgress', precentCompleted);
            },
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            params,
          },
        );
        commit('setData', response.data);
        commit('setUploadedFile', file);
      } catch (error) {
        if (isMaxFileSizeError(error)) {
          const errorMsg = `The file size should not exceed ${CONTACTS_IMPORT_MAX_SIZE_MB} MB`;
          commit('setError', errorMsg);
        } else if (isMaxUploadLimit(error)) {
          const errorMsg = `You have reached the limit of daily uploads`;
          commit('setError', errorMsg);
        } else if (isAPIError(error)) {
          commit('setError', error.data.error);
        } else {
          commit('setError', error);
        }
      }
      commit('setLoading', false);
    },
    async deleteImportFile({ commit }, fileID) {
      commit('setLoading', true);
      try {
        await axios.delete(`${process.env.VUE_APP_FILE_UPLOADER_API_BASE_URL}/upload/import-file/${fileID}`);
        commit('clearMessages');
      } catch (error) {
        if (isAPIError(error)) {
          commit('setError', error.data.error);
        } else {
          commit('setError', error);
        }
      }
      commit('setLoading', false);
    },
  },
};
